import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AddressServiceInterface } from './address.interface';

@Injectable({
  providedIn: 'root'
})
export class AddressService implements AddressServiceInterface {

  constructor(private httpClient: HttpClient) {
  }

  GetCityTownBySearchFragment(searchFragment: string): Observable<string[]> {
    return this.httpClient.post<any>(environment.apiBaseUrl + `Address/getByName`, {SearchFragment: searchFragment}, {reportProgress: true});
  }
}
